import { render, staticRenderFns } from "./SidebarPost.vue?vue&type=template&id=8f0bffe0&"
import script from "./SidebarPost.vue?vue&type=script&lang=js&"
export * from "./SidebarPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports